import ProjectTemplate from '../../components/common/ProjectTemplate';
import ConveyorListContainer from '../../components/conveyor/ConveyorListContainer';
import ConveyorListActionButtons from '../../components/conveyor/ConveyorListActionButtons';

const ConveyorListPage = () => {
    return (
        <ProjectTemplate>
            <ConveyorListContainer />
            <ConveyorListActionButtons />
        </ProjectTemplate>
    );
};

export default ConveyorListPage;
